import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StaticMsgModule } from '@lib/pipes';
import { PetEasyTravelRequestSubHeaderComponent } from './pet-easy-travel-request-sub-header.component';
import { RouterModule } from '@angular/router';
import { TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';

@NgModule({
  declarations: [PetEasyTravelRequestSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, RouterModule, TextTooltipModule, TooltipDirectiveModule],
  exports: [PetEasyTravelRequestSubHeaderComponent],
})
export class PetEasyTravelRequestSubHeaderModule {}
